var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatcha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 611 108",
    style: {
      enableBackground: "new 0 0 611 108"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01C482;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.3,104.7c-1.9,0-3.3-1.9-2.7-3.7l31.9-96.2c0.4-1.1,1.5-1.9,2.7-1.9h47c1.2,0,2.3,0.8,2.7,1.9l30.8,96.2 c0.6,1.8-0.8,3.7-2.7,3.7h-47.2c-1.4,0-2.5-1-2.8-2.3l-2-11.2c-0.2-1.3-1.4-2.3-2.8-2.3h-16.4c-1.3,0-2.4,0.9-2.7,2.2l-2.8,11.5 c-0.3,1.3-1.4,2.2-2.7,2.2H497.3z M539.7,63c-0.4,1.8,0.9,3.5,2.7,3.5h5.1c1.7,0,3.1-1.6,2.8-3.3l-2.1-12.4c-0.5-3-4.8-3.2-5.5-0.2 L539.7,63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.3,104.7c-1.5,0-2.8-1.3-2.8-2.8V52.4c0-1.5-1.3-2.8-2.8-2.8h-4.6c-1.5,0-2.8,1.3-2.8,2.8v49.5 c0,1.5-1.3,2.8-2.8,2.8h-44.7c-1.5,0-2.8-1.3-2.8-2.8V5.7c0-1.5,1.3-2.8,2.8-2.8h44.7c1.5,0,2.8,1.3,2.8,2.8v20.7 c0,1.5,1.3,2.8,2.8,2.8h4.6c1.5,0,2.8-1.3,2.8-2.8V5.7c0-1.5,1.3-2.8,2.8-2.8H499c1.5,0,2.8,1.3,2.8,2.8v96.2c0,1.5-1.3,2.8-2.8,2.8 H454.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342,107.6c-33.4,0-55.7-21.4-55.7-53.5c0-32.4,23.6-54.1,57-54.1c22.4,0,38.9,9.8,48,27.1 c0.9,1.7-0.2,3.6-2.1,3.9l-25.1,3.1c-1.3,0.2-2.4-0.6-3.1-1.7c-1.8-2.9-4.7-4.6-8.5-4.6c-6,0-10,4.2-10,10.3 c0,6.1,4.1,10.6,9.9,10.6c3.7,0,6.9-1.8,8.9-5.1c0.6-1,1.7-1.7,2.9-1.5l29.8,2.7c1.2,0.1,2.2,0.9,2.4,2.1c0.6,2.8,1,5.8,1,9.7 C397.4,86.8,375,107.6,342,107.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.9,104.7c-1.5,0-2.8-1.3-2.8-2.8V26.1c0-1.5-1.3-2.8-2.8-2.8h-16.5c-1.5,0-2.8-1.3-2.8-2.8V5.7 c0-1.5,1.3-2.8,2.8-2.8h88.9c1.5,0,2.8,1.3,2.8,2.8v14.7c0,1.5-1.3,2.8-2.8,2.8h-16.5c-1.5,0-2.8,1.3-2.8,2.8v75.8 c0,1.5-1.3,2.8-2.8,2.8H231.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.2,104.7c-1.9,0-3.3-1.9-2.7-3.7l31.9-96.2c0.4-1.1,1.5-1.9,2.7-1.9h47c1.2,0,2.3,0.8,2.7,1.9l30.8,96.2 c0.6,1.8-0.8,3.7-2.7,3.7h-47.2c-1.4,0-2.5-1-2.8-2.3l-2-11.2c-0.2-1.3-1.4-2.3-2.8-2.3h-16.4c-1.3,0-2.4,0.9-2.7,2.2l-2.8,11.5 c-0.3,1.3-1.4,2.2-2.7,2.2H118.2z M160.7,63c-0.4,1.8,0.9,3.5,2.7,3.5h5.1c1.7,0,3.1-1.6,2.8-3.3l-2.1-12.4c-0.5-3-4.8-3.2-5.5-0.2 L160.7,63z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,100.2c-0.9,2.3-4.3,2.3-5.2,0L49,84.3c-1.1-2.9-5.4-2-5.4,1v16.5c0,1.5-1.3,2.8-2.8,2.8h-38 c-1.5,0-2.8-1.3-2.8-2.8V5.7c0-1.5,1.3-2.8,2.8-2.8h41.4c1,0,2,0.6,2.5,1.5l9.1,17.4c1,2,3.9,2,5,0l9.1-17.4 c0.5-0.9,1.4-1.5,2.5-1.5h47.6c1.5,0,2.8,1.3,2.8,2.8v96.2c0,1.5-1.3,2.8-2.8,2.8H75.2c-1.5,0-2.8-1.3-2.8-2.8V85.3 c0-3.1-4.3-3.9-5.4-1L60.6,100.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatcha);
export default __webpack_public_path__ + "static/media/MATCHA.e6b61281f1ff414e4b6bacca3695559f.svg";
export { ForwardRef as ReactComponent };